import { render, staticRenderFns } from "./variantAttributes.vue?vue&type=template&id=2256de0c&scoped=true"
import script from "./variantAttributes.vue?vue&type=script&lang=js"
export * from "./variantAttributes.vue?vue&type=script&lang=js"
import style0 from "./variantAttributes.vue?vue&type=style&index=0&id=2256de0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256de0c",
  null
  
)

export default component.exports